import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_oriontrading.png",
      alt: "Estratégias Orion Trading",
    },
    title: "Invista utilizando métodos científicos e robustos",

    // String ou array de strings
    text: "Estratégias desenvolvidas e testadas com rigor científico. Métodos de trading baseados em abordagens utilizadas pelos maiores nomes da história do trading.",
    testimonial: {
      text: "Cada uma de nossas estratégias é baseada nos princípios da robustez. Nós não acreditamos na utilização de fórmulas ou combinações mágicas de trading, mas sim na pesquisa e aprimoramento contínuos. Sabemos que modelos robustos são os que tendem a prevalecer no mercado",
      author: {
        name: "Lucas Notini, Estrategista da Orion Robust Trading.",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Orion Robust Trading",
    heading: "Invista com o poder do Algo Trading",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Orion Trading.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Orion Trading",
    col1: [
      "Levamos o Trading a sério! Acreditamos que o algo trading (trading automatizado) é uma ótima solução de investimentos para investidores iniciantes e também para aqueles que já conhecem o ambiente da renda variável.",
      "Utilizamos estratégias construídas com o rigor científico e que são constantemente monitoradas e aprimoradas por nossa equipe especialista. Acreditamos em métodos que funcionam nos mais variados cenários de trading. Sabemos que o mercado evolui e por isso buscamos estar sempre um passo à sua frente.",
    ],
    col2: [
      "Skin in the game! Operamos com nossos métodos em conta real, assim nos mantemos juntos aos nossos parceiros e investidores, nos motivando a cultivar um ciclo de melhoria contínua.",
    ],
  },

  stats: {
    title: "Conheça alguns números da Orion",
    subtitle:
      "Sinta-se em boas mãos com algoritmos robustos de investimentos ao seu dispor.",
    data: [
      {
        value: "+5",
        description: "Anos de experiência em Trading Quantitativo",
      },
      {
        value: "+50",
        description: "Estratégias lucrativas validadas estatisticamente",
      },
      {
        value: "+5",
        description: "Anos lucrativos por método",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da Orion?",
    subtitle: "Veja quais as principais vantagens dos robôs da Orion Trading",
    data: [
      {
        icon: iconsSet.play_circle,
        title: "Simples e eficaz",
        description:
          "Você não precisa ser um especialista, opere como um profissional simplesmente apertando o play em uma de nossas estratégias.",
      },
      {
        icon: iconsSet.tune,
        title: "Estratégias que se adaptam",
        description:
          "Todos os nossos métodos de trading são desenvolvidos de forma a se adaptarem às mais diversas condições",
      },
      {
        icon: iconsSet.settings_outline,
        title: "Decisões 100% automatizadas",
        description:
          "Estratégias robustas de trading onde não há interferência humana na tomada de decisões",
      },
      {
        icon: iconsSet.analytics,
        title: "Gestão de riscos",
        description:
          "O controle de riscos é prioridade absoluta em nossas estratégias de trading.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte ao cliente",
        description:
          "Nos mantemos próximos aos nossos clientes para tirar dúvidas e prestar atendimento pelos nossos canais",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description:
          "Sabemos que lidar com as emoções é o que leva muitos traders à ruína e, por isso, confiamos a tomada de decisões aos nossos algoritmos!",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "São pessoas sérias, responsáveis e compromissadas com os trabalhos que assumem. Além disso demonstram conhecimento, prática e domínio no que fazem.",
      author: "Richard Hernani",
      job: "Empresário",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "A empresa tem uma equipe altamente capacitada e que preza pela transparência no que faz. Confio no trabalho deles por saber que levam o trading realmente a sério e entregam resultados.",
      author: "Renato Vilela",
      job: "Engenheiro",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
